import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = {
  key: 0,
  class: "text-primary-blue ms-1"
}
const _hoisted_3 = ["href"]

import conditionsUrl from "../../../computed/conditionsUrl"


export default /*@__PURE__*/_defineComponent({
  __name: 'TermsAndConditions',
  setup(__props) {

// Imported copmuted
const content = window.content

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("a", {
      href: _unref(conditionsUrl),
      target: "_blank",
      class: "text-primary-blue text-decoration-underline"
    }, _toDisplayString(_unref(content).terms_and_conditions_1), 9, _hoisted_1),
    (_unref(content).terms_and_conditions_2)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(content).terms_and_conditions_2), 1))
      : _createCommentVNode("", true),
    (_unref(content).terms_and_conditions_3)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _unref(conditionsUrl),
          target: "_blank",
          class: "text-primary-blue text-decoration-underline"
        }, _toDisplayString(_unref(content).terms_and_conditions_3), 9, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})